import { useMutation, useQueryClient } from 'react-query';
import { get } from 'lodash';
import { useToast } from 'src/context/ToastProvider';
import { undoOfflineDriveLastRound } from 'src/apis/offlineDrive';

export const useUndoOfflineDriveLastRound = ({
	onComplete,
	driveId,
}: {
	onComplete?: () => void;
	driveId: string;
}) => {
	const queryClient = useQueryClient();
	const toast = useToast();
	return useMutation(['undoOfflineDriveLastRound'], undoOfflineDriveLastRound, {
		onSuccess() {
			queryClient.invalidateQueries({ queryKey: ['getOfflineDriveCandidates', driveId] });
			queryClient.refetchQueries({ queryKey: ['getOfflineDriveCandidates', driveId] });
			queryClient.invalidateQueries({ queryKey: ['getOfflineDriveParticipateCandidates', driveId] });
			toast({ title: 'Assignment undone — candidate returned to previous state.' });
			onComplete?.();
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				type: 'error',
				title: errorMessage,
			});
		},
	});
};
